import * as React from 'react';
import { Properties, Values, Validation, DropdownTabbed } from '../';
import { IControl, DOMHelper, PropertyHelper, EControlTypes, IOperator, IValidationConfig, QueryBuilderHelper, OutputsHelper, EValidationContext, EModalType, ControlHelper, IFieldConfig, IProperty, EPropertyTypes, IQuickFormLayout, IQuickForm } from '../../helpers';
import { NON_REPEATABLE_CONTROL_TYPES, VALIDATION_EXPRESSION_PROPERTY_NAME } from '../../constants';
import {
    DialogFooter,
    Button, ButtonType,
    Pivot, PivotItem, PivotLinkSize, IDropdownOption,
    Label
} from 'office-ui-fabric-react';
import OutputSelectContainer from "../../containers/output-select";
import store from '../../store/store';
import { ListOfItems } from '../common/list-of-items';
import Collapsible from 'react-collapsible';

interface IOptionHandler {
    addOption: () => void;
    updateOptionLabel: (index: number, label: string) => void;
    updateOptionValue: (index: number, value: string) => void;
    updateOptionImageUrl: (index: number, value: string) => void;
    removeOption: (index: number) => void;
    moveOption: (fromIndex: number, toIndex: number) => void;
};

interface IItemHandler {
    addItem: () => void;
    updateItemLabel: (index: number, label: string) => void;
    updateItemURL: (index: number, value: string) => void;
    updateItemIcon: (index: number, value: string) => void;
    removeItem: (index: number) => void;
    moveItem: (fromIndex: number, toIndex: number) => void;
};

interface IProps {
    control: IControl;
    isRepeatableBlock: boolean;
    fromIndex: number;
    overIndex: number;
    controlTypes: any[];
    dropdownChange: (item: any) => void;
    change: (key: string, value: any) => void;
    updateFormField: (formId: string, controlId: string, propertyName: string, value: any) => void;
    closeDialog: (save?: boolean, optionsDefinedByJSON?: boolean, isNewBlock?: boolean) => void;
    deleteControl: () => void;
    onLoad: (control: IControl) => void;
    isControlTypeDropdownDisabled: (control: IControl) => boolean;
    isDeleteButtonDisabled: (control: IControl) => boolean;
    operators: IOperator[];
    operatorTypes: string[];
    outputOptions: IDropdownOption[];
    globalOutputDropdownOptions: IDropdownOption[];
    optionHandler: IOptionHandler;
    itemHandler?: IItemHandler;
    updateOutput: (i: number, name: string) => void;
    outputBlur: (index: number, name: string, staticName: string, logicalName: string) => void;
    updateSelectedGlobalOutput: (index: number, key: string) => void;
    updateOutputLogicalName: (index: number, logicalName: string) => void;
    updateOutputDefaultValue: (index: number, defaultValue: string) => void;
    setAdvancedSettingsIndex: (index: number) => void;
    advancedSettingsIndex: number;
    validationEditIndex: number;
    editedValidationItem: IValidationConfig;
    updateEditedValidationItem: (editedValidationItem: IValidationConfig) => void;
    setValidationEditIndex: (validationEditIndex: number) => void;
    showPivotErrorMessage: () => void;
    hasErrors: boolean;
    showBlockContent?: boolean;
    changeShowBlockContent?: (val: boolean) => void;
    showBlockTabs?: boolean;
    isNewBlock?: boolean;
    changeShowBlockTabs?: (val: boolean) => void;
    changeShowNewBlock?: (val: boolean) => void;
    changeCurrentControlIndex?: (val: number) => void;
    addNewLayoutPanel?: (componentId: string) => void
    componentId?: string;
    updateEntityProperty?: (key: string, value: any) => void;
    changeEntityView?: (key: string, value: any) => void;
    changeEntityForm?: (key: string, value: any) => void;
    changeEntityViewColumn?: (key: string, value?: any) => void;
    entityViews?: IDropdownOption[];
    entityForms?: IDropdownOption[];
    entityFormattedAttributes?: { [id: string]: string; };
    entityViewColumns?: any[];
    fieldConfigs?: IFieldConfig[];
    areEntityFormsLoading?: boolean;
    areEntityViewsLoading?: boolean;


};
let isPropertiesVisible: boolean = false;

export class ControlConfig extends React.Component<IProps, any> {
    constructor(props: any) {
        super(props);

        this.state = {
            openQuickCreateForm: false,
            openQuickEditForm: false
        };
        this.changeShowBlockContent = this.changeShowBlockContent.bind(this);
        this.changeShowBlockTabs = this.changeShowBlockTabs.bind(this);

    }
    changeShowBlockContent() {
        const newShowBlockContent = this.props.showBlockContent;
        this.props.changeShowBlockContent(true);
    }
    changeShowBlockTabs() {
        const newShowBlockContent = this.props.showBlockTabs;
        this.props.changeShowBlockContent(true);
    }

    public componentDidMount() {
        let { control, onLoad } = this.props;
        onLoad(control);
        DOMHelper.setDropdownPropertyTabIndex();
        DOMHelper.focusOnFirstModalTabbableControl();
    }

    public componentDidUpdate(prevProps) {
        DOMHelper.setDropdownPropertyTabIndex();
        if (!(prevProps.control.ControlType) ||
            (prevProps.control.ControlType.NameType !== this.props.control.ControlType.NameType) ||
            (prevProps.control.Properties.length !== this.props.control.Properties.length)
        ) {
            DOMHelper.focusOnFirstModalTabbableControl();
        }
    }

    private removeCurrentControlsOutputs(outputOptions: IDropdownOption[]): IDropdownOption[] {

        let { control } = this.props;

        if (control && control.OutputValues && control.OutputValues.length) {

            return outputOptions.filter(o => {
                return !control.OutputValues.some(v => v.Id === o.key.toString());
            });

        }

        return outputOptions;

    }

    public render() {

        let {
            control, overIndex, change, updateFormField, updateEntityProperty, changeEntityView, changeEntityForm, changeEntityViewColumn, fieldConfigs, entityViews, entityForms,
            entityFormattedAttributes, entityViewColumns, controlTypes, closeDialog, deleteControl, dropdownChange, isControlTypeDropdownDisabled, isDeleteButtonDisabled, outputOptions,
            globalOutputDropdownOptions, optionHandler, itemHandler, updateOutput, updateSelectedGlobalOutput, outputBlur, updateOutputLogicalName, setAdvancedSettingsIndex,
            advancedSettingsIndex, updateOutputDefaultValue, isRepeatableBlock, operators, operatorTypes, validationEditIndex, editedValidationItem,
            updateEditedValidationItem, setValidationEditIndex, showPivotErrorMessage, hasErrors, showBlockContent, changeShowBlockContent,
            showBlockTabs, changeShowBlockTabs, changeShowNewBlock, isNewBlock, changeCurrentControlIndex, addNewLayoutPanel, componentId, areEntityFormsLoading, areEntityViewsLoading
        } = this.props;
        let outputs = control.OutputValues;
        let options = control.Properties.filter(p => p.Name === 'Value Options')[0];
        let items = control.Properties.filter(p => p.Name === 'Items')[0];
        let jsonText: string = '';
        let jsonOptions = PropertyHelper.getPropertyValue(control.Properties, 'Json Options');
        if (jsonOptions && jsonOptions.length) {
            try {
                jsonText = JSON.parse(jsonOptions).text;
                jsonText = jsonText.trim();
            }
            catch (e) {
                //invalid JSON in jsonOptions
            }
        }

        if (isRepeatableBlock) {
            controlTypes = controlTypes.filter(t => NON_REPEATABLE_CONTROL_TYPES.indexOf(t.key) < 0);
        }

        let usePropertyDefaults = PropertyHelper.getPropertyValue(control.Properties, 'Use Centrally Configured Zoom Levels');
        let styleValue: string = control.ControlType.NameType.toLowerCase() === 'list of options' || control.ControlType.NameType.toLowerCase() === 'multi select control' ?
            PropertyHelper.getPropertyValue(control.Properties, "Style") : '';

        let optionsDefinedByJSON: boolean = jsonText.length > 0;

        control.OutputValues;
        let controlsWithoutQuickForms = control.Properties.filter(x => x.Name !== "Quick Create Form" && x.Name !== "Quick Create Form Fields" && x.Name !== "Quick Edit Form" && x.Name !== "Quick Edit Form Fields" );

        let isNewBlockItem: JSX.Element[] = [
            isNewBlock ?
                <PivotItem key="pivot_control_isNewBlockItem" linkText='Control'>
                    <div>
                        <Properties primaryOnly={false}
                            change={change}
                            fields={fieldConfigs}
                            changeEntity={updateEntityProperty}
                            changeEntityForm={changeEntityForm}
                            changeEntityView={changeEntityView}
                            changeEntityViewColumn={changeEntityViewColumn}
                            entityViews={entityViews}
                            entityForms={entityForms}
                            entityFormattedAttributes={entityFormattedAttributes}
                            entityViewColumns={entityViewColumns}
                            componentId={control.ComponentId}
                            properties={controlsWithoutQuickForms}
                            outputOptions={OutputsHelper.removeSpecifiedOutputOptions(outputOptions, control.OutputValues)}
                            useDefaults={usePropertyDefaults}
                            controlType={control.ControlType}
                            areEntityFormsLoading={areEntityFormsLoading}
                            areEntityViewsLoading={areEntityViewsLoading}
                        />
                    </div>
                    {/* {control.Properties.length ?
                        <DialogFooter>
                            <Button tabIndex={1001}
                                buttonType={ButtonType.normal} disabled={isDeleteButtonDisabled(control)}
                                onClick={(event) => {
                                    deleteControl();
                                    event.stopPropagation();
                                }}>Delete</Button>
                            <Button tabIndex={1002}
                                buttonType={ButtonType.normal} onClick={() => { closeDialog(false) }}>Cancel</Button>
                            <Button tabIndex={1003} onBlur={() => { DOMHelper.focusOnFirstModalTabbableControl(); }}
                                buttonType={ButtonType.primary} onClick={() => { closeDialog(true, optionsDefinedByJSON, true) }}>Save</Button>
                        </DialogFooter>
                        : null} */}
                </PivotItem>
                : null
        ];

        // Control properties
        let pivots: JSX.Element[] = [
            showBlockTabs ?
                <PivotItem key="pivot_control" linkText='Control'>
                    {
                        isControlTypeDropdownDisabled(control) ?
                            <div><Label>Control Type: {control.ControlType.NameType}</Label></div>
                            :
                            <div></div>
                    }
                    {
                        !showBlockContent ?
                            <div>
                                <Properties primaryOnly={false}
                                    fields={fieldConfigs}
                                    change={change}
                                    changeEntityForm={changeEntityForm}
                                    changeEntity={updateEntityProperty}
                                    changeEntityView={changeEntityView}
                                    changeEntityViewColumn={changeEntityViewColumn}
                                    entityViews={entityViews}
                                    entityForms={entityForms}
                                    entityFormattedAttributes={entityFormattedAttributes}
                                    entityViewColumns={entityViewColumns}
                                    componentId={control.ComponentId}
                                    properties={controlsWithoutQuickForms}
                                    outputOptions={OutputsHelper.removeSpecifiedOutputOptions(outputOptions, control.OutputValues)}
                                    useDefaults={usePropertyDefaults} controlType={control.ControlType}
                                    areEntityFormsLoading={areEntityFormsLoading}
                                    areEntityViewsLoading={areEntityViewsLoading}
                                />
                            </div> : null
                    }
                </PivotItem>
                :
                <PivotItem key="pivot_control">
                    {
                        isControlTypeDropdownDisabled(control) ?
                            <div><Label>Control Type: {control.ControlType.NameType}</Label></div> :
                            <div>
                                <div className="new-layout-block">
                                    <Button
                                        className="btn-new-layout"
                                        tabIndex={1100}
                                        buttonType={ButtonType.primary}
                                        onClick={() => {
                                            addNewLayoutPanel(componentId)
                                            changeShowBlockContent(true);
                                        }} >
                                        New Layout Panel
                                    </Button>
                                </div>

                                <div className="block-config-create ms-Grid">
                                    <div className="block-config-create-container ms-Grid-row">
                                        {
                                            controlTypes.map((val, index) => {
                                                return (
                                                    // <div key={'block-config-create_' + index}>
                                                    <div key={val.key} className="block-config-create-item ms-Grid-col ms-u-sm3 block" onClick={() => {
                                                        dropdownChange(val);
                                                        changeShowBlockContent(true);
                                                        changeShowBlockTabs(true);
                                                        changeShowNewBlock(true);
                                                    }}>
                                                        <div className="ms-Grid-row block-config-create-icon" title={val.key}>
                                                            <i className={`ms-Icon ms-Icon--${ControlHelper.getControlIcon(val.key)}`} aria-hidden="true"></i>
                                                        </div>
                                                        <div className="ms-Grid-row block-config-create-label" title={val.key}>{val.key}</div>
                                                    </div>
                                                    // </div>
                                                );
                                            })
                                        }
                                    </div>
                                </div>
                            </div >
                    }
                </PivotItem >];

        // Quick form panel
        let isGetViewControl = control.ControlType.NameType === "Get View" || control.ControlType.NameType === "Create Form";
        if (isGetViewControl && showBlockTabs) {
            let quickCreateProperties = control.Properties.filter(x => x.Name === "Quick Create Form" || x.Name === "Quick Create Form Fields");
            let quickEditProperties = control.Properties.filter(x => x.Name === "Quick Edit Form" || x.Name === "Quick Edit Form Fields");
            let quickForms = store.getState().modalState.controlConfig.quickForms;

            let selectedQuickForm: IQuickForm = quickForms.length && quickCreateProperties.length && quickForms.filter(quickForm => quickForm.formId === quickCreateProperties[0].Value)[0];

            let doesQuickCreateFormFieldsExist = control.Properties && control.Properties.filter(x => x.Name === "Quick Create Form Fields").length;
            // let formFieldValues = (doesQuickCreateFormFieldsExist && doesQuickCreateFormFieldsExist !== 0) ? JSON.parse(control.Properties.filter(x => x.Name === "Quick Create Form Fields")[0].Value.toString()) : null;
            // const isSameQuickForm = formFieldValues ? formFieldValues.formId === selectedQuickForm.formId : false;

            let formFieldProperties: JSX.Element[] = [];

            quickCreateProperties && quickCreateProperties.length && quickCreateProperties[0].Value ?
                quickForms &&
                quickForms.filter(quickForm => quickForm.formId === quickCreateProperties[0].Value).length &&
                quickForms.filter(quickForm => quickForm.formId === quickCreateProperties[0].Value)[0].layout.forEach((layout: IQuickFormLayout) => {
                    let formFieldsProperties: IProperty[] = [];
                    layout.controls.length && layout.controls.forEach((formControl: IControl) => {
                        let formFieldValue = doesQuickCreateFormFieldsExist && control.Properties.filter(x => x.Name === "Quick Create Form Fields")[0].Value ?
                            // JSON.parse(control.Properties.filter(x => x.Name === "Quick Create Form Fields")[0].Value.toString()).layout.map(x => x.controls).flat().filter(x => x.ControlId === formControl.ControlId)[0].Value
                            layout.controls.filter(x => x.ControlId === formControl.ControlId)[0].Value
                            : formControl.Value;

                        const property: IProperty =
                        {
                            Id: formControl.ControlId,
                            Name: formControl.FriendlyName,
                            Value: formControl.Value,
                            Type: EPropertyTypes.dynamic,
                            IsPrimary: false,
                            IsQuickCreateProperty: true,
                            IsInvisible: false,
                            IsHidden: false,
                        };
                        formFieldsProperties.push(property);

                    });

                    formFieldProperties.push(<Properties primaryOnly={false}
                        formId={quickForms.filter(quickForm => quickForm.formId === quickCreateProperties[0].Value)[0].formId}
                        fields={fieldConfigs}
                        change={change}
                        updateFormField={updateFormField}
                        changeEntityForm={changeEntityForm}
                        changeEntity={updateEntityProperty}
                        changeEntityView={changeEntityView}
                        changeEntityViewColumn={changeEntityViewColumn}
                        entityViews={entityViews}
                        entityForms={entityForms}
                        entityFormattedAttributes={entityFormattedAttributes}
                        entityViewColumns={entityViewColumns}
                        componentId={control.ComponentId}
                        properties={formFieldsProperties}
                        outputOptions={OutputsHelper.removeSpecifiedOutputOptions(outputOptions, control.OutputValues)}
                        useDefaults={usePropertyDefaults} controlType={control.ControlType}
                        areEntityFormsLoading={areEntityFormsLoading}
                        areEntityViewsLoading={areEntityViewsLoading}
                    />
                    );

                })
                :
                null;


            let editFormFieldProperties: JSX.Element[] = [];

            quickEditProperties && quickEditProperties.length && quickEditProperties[0].Value ?
                quickForms &&
                quickForms.filter(quickForm => quickForm.formId === quickEditProperties[0].Value).length &&
                quickForms.filter(quickForm => quickForm.formId === quickEditProperties[0].Value)[0].layout.forEach((layout: IQuickFormLayout) => {
                    let formFieldsProperties: IProperty[] = [];
                    layout.controls.length && layout.controls.forEach((formControl: IControl) => {
                        let formFieldValue = doesQuickCreateFormFieldsExist && control.Properties.filter(x => x.Name === "Quick Edit Form Fields")[0].Value ?
                            // JSON.parse(control.Properties.filter(x => x.Name === "Quick Create Form Fields")[0].Value.toString()).layout.map(x => x.controls).flat().filter(x => x.ControlId === formControl.ControlId)[0].Value
                            layout.controls.filter(x => x.ControlId === formControl.ControlId)[0].Value
                            : formControl.Value;

                        const property: IProperty =
                        {
                            Id: formControl.ControlId,
                            Name: formControl.FriendlyName,
                            Value: formControl.Value,
                            Type: EPropertyTypes.dynamic,
                            IsPrimary: false,
                            IsQuickCreateProperty: true,
                            IsInvisible: false,
                            IsHidden: false,
                        };
                        formFieldsProperties.push(property);

                    });

                    editFormFieldProperties.push(<Properties primaryOnly={false}
                        formId={quickForms.filter(quickForm => quickForm.formId === quickEditProperties[0].Value)[0].formId}
                        fields={fieldConfigs}
                        change={change}
                        updateFormField={updateFormField}
                        changeEntityForm={changeEntityForm}
                        changeEntity={updateEntityProperty}
                        changeEntityView={changeEntityView}
                        changeEntityViewColumn={changeEntityViewColumn}
                        entityViews={entityViews}
                        entityForms={entityForms}
                        entityFormattedAttributes={entityFormattedAttributes}
                        entityViewColumns={entityViewColumns}
                        componentId={control.ComponentId}
                        properties={formFieldsProperties}
                        outputOptions={OutputsHelper.removeSpecifiedOutputOptions(outputOptions, control.OutputValues)}
                        useDefaults={usePropertyDefaults} controlType={control.ControlType}
                        areEntityFormsLoading={areEntityFormsLoading}
                        areEntityViewsLoading={areEntityViewsLoading}
                    />
                    );

                })
                :
                null;

            if (showBlockTabs) {
                const newPivotElement = <PivotItem key="quick_create" linkText='New/Edit Form'>

                    <Collapsible className="quick-create-form" onClick={(e) => { this.setState({ openQuickCreateForm: !this.state.openQuickCreateForm }); }}
                        trigger={
                            <div className="quick-create-form-control">
                                <i className={`ms-Icon ms-Icon--${this.state.openQuickCreateForm ? 'ChevronDown' : 'ChevronRight'}`} aria-hidden="true"></i>
                                <h4>Quick Create Form</h4>
                            </div>
                        }
                        open={this.state.openQuickCreateForm} >
                        {/* {this.state.openQuickCreateForm ? */}
                            <Properties primaryOnly={false}
                                fields={fieldConfigs}
                                change={change}
                                changeEntityForm={changeEntityForm}
                                changeEntity={updateEntityProperty}
                                changeEntityView={changeEntityView}
                                changeEntityViewColumn={changeEntityViewColumn}
                                entityViews={entityViews}
                                entityForms={entityForms}
                                entityFormattedAttributes={entityFormattedAttributes}
                                entityViewColumns={entityViewColumns}
                                componentId={control.ComponentId}
                                properties={quickCreateProperties}
                                outputOptions={OutputsHelper.removeSpecifiedOutputOptions(outputOptions, control.OutputValues)}
                                useDefaults={usePropertyDefaults} controlType={control.ControlType}
                                areEntityFormsLoading={areEntityFormsLoading}
                                areEntityViewsLoading={areEntityViewsLoading}
                            />
                            {/* : null
                        }
 */}
                        {
                            formFieldProperties.length ?
                                <div className="form-field-group">
                                    <span className="">Form Fields:</span>
                                    <div className="form-fields">
                                        {formFieldProperties}
                                    </div>
                                </div>
                                : null
                        }

                    </Collapsible >

                    <Collapsible className="quick-edit-form" onClick={(e) => { this.setState({ openQuickEditForm: !this.state.openQuickEditForm }); }}
                        trigger={
                            <div className="quick-edit-form-control">
                                <i className={`ms-Icon ms-Icon--${this.state.openQuickCreateForm ? 'ChevronDown' : 'ChevronRight'}`} aria-hidden="true"></i>
                                <h4>Quick Edit Form</h4>
                            </div>
                        } open={this.state.openQuickEditForm} >

                        <Properties primaryOnly={false}
                            fields={fieldConfigs}
                            change={change}
                            changeEntityForm={changeEntityForm}
                            changeEntity={updateEntityProperty}
                            changeEntityView={changeEntityView}
                            changeEntityViewColumn={changeEntityViewColumn}
                            entityViews={entityViews}
                            entityForms={entityForms}
                            entityFormattedAttributes={entityFormattedAttributes}
                            entityViewColumns={entityViewColumns}
                            componentId={control.ComponentId}
                            properties={quickEditProperties}
                            outputOptions={OutputsHelper.removeSpecifiedOutputOptions(outputOptions, control.OutputValues)}
                            useDefaults={usePropertyDefaults} controlType={control.ControlType}
                            areEntityFormsLoading={areEntityFormsLoading}
                            areEntityViewsLoading={areEntityViewsLoading}
                        />
                        {
                            editFormFieldProperties.length ?
                                <div className="form-field-group">
                                    <span className="">Form Fields:</span>
                                    <div className="form-fields">
                                        {editFormFieldProperties}
                                    </div>
                                </div>
                                : null
                        }
                    </Collapsible>
                </PivotItem >;
                pivots.push(newPivotElement);
                isNewBlockItem.push(newPivotElement);
            }
        }

        // List of item panel
        let isListOfItemControl = control.ControlType.NameType === "List Of Items";
        if (isListOfItemControl && showBlockTabs) {
            let listOfItemsProperties = control.Properties.filter(x => x.Name === "Items");
            const newPivotElement = <PivotItem key="pivot_values" linkText='Items'>
                <ListOfItems
                    displayOnlyOutputs={true}
                    outputs={outputs}
                    advancedSettingsIndex={advancedSettingsIndex}
                    globalOutputDropdownOptions={globalOutputDropdownOptions}
                    outputDropdownOptions={outputOptions}
                    options={items ? items.ValueOptions : null}
                    itemHandler={itemHandler}
                    outputHandler={{
                        updateOutput: updateOutput,
                        updateOutputLogicalName: updateOutputLogicalName,
                        outputBlur: outputBlur,
                        updateSelectedGlobalOutput: updateSelectedGlobalOutput,
                        setAdvancedSettingsIndex: setAdvancedSettingsIndex,
                        updateOutputDefaultValue: updateOutputDefaultValue
                    }}
                    showImageUrlField={styleValue === 'RadioButtons' || styleValue === 'TickBox'}
                    overIndex={overIndex} />
            </PivotItem>;
            pivots.push(newPivotElement);
            isNewBlockItem.push(newPivotElement);
        }

        // Visibility panel
        if (showBlockTabs) {
            const newPivotElement = <PivotItem key="pivot_visibility" linkText='Visibility'>
                <Properties primaryOnly={false}
                    fields={fieldConfigs}
                    change={change}
                    changeEntityForm={changeEntityForm}
                    changeEntity={updateEntityProperty}
                    changeEntityView={changeEntityView}
                    changeEntityViewColumn={changeEntityViewColumn}
                    entityViews={entityViews}
                    entityForms={entityForms}
                    entityFormattedAttributes={entityFormattedAttributes}
                    entityViewColumns={entityViewColumns}
                    componentId={control.ComponentId} properties={control.Properties}
                    outputOptions={OutputsHelper.removeSpecifiedOutputOptions(outputOptions, control.OutputValues)}
                    useDefaults={usePropertyDefaults} controlType={control.ControlType} showOnlyVisibility={true}
                    areEntityFormsLoading={areEntityFormsLoading}
                    areEntityViewsLoading={areEntityViewsLoading}
                />
            </PivotItem>;
            pivots.push(newPivotElement);
            isNewBlockItem.push(newPivotElement);
        }

        // Values panel
        if ((outputs || (options && !optionsDefinedByJSON)) && showBlockTabs) {
            const newPivotElement = <PivotItem key="pivot_values" linkText='Values'>
                <Values
                    displayOnlyOutputs={true}
                    outputs={outputs}
                    advancedSettingsIndex={advancedSettingsIndex}
                    globalOutputDropdownOptions={globalOutputDropdownOptions}
                    outputDropdownOptions={outputOptions}
                    options={optionsDefinedByJSON || !options ? null : options.ValueOptions}
                    optionHandler={optionHandler}
                    outputHandler={{
                        updateOutput: updateOutput,
                        updateOutputLogicalName: updateOutputLogicalName,
                        outputBlur: outputBlur,
                        updateSelectedGlobalOutput: updateSelectedGlobalOutput,
                        setAdvancedSettingsIndex: setAdvancedSettingsIndex,
                        updateOutputDefaultValue: updateOutputDefaultValue
                    }}
                    showImageUrlField={styleValue === 'RadioButtons' || styleValue === 'TickBox'}
                    overIndex={overIndex} />
            </PivotItem>;
            pivots.push(newPivotElement);
            isNewBlockItem.push(newPivotElement);
        }

        //Validation panel
        let validationExpressions = PropertyHelper.getProperty(control.Properties, VALIDATION_EXPRESSION_PROPERTY_NAME);
        if (validationExpressions && showBlockTabs) {
            const newPivotElement = <PivotItem key="" linkText="Validation">
                <Validation
                    operators={operators}
                    operatorTypes={operatorTypes}
                    value={validationExpressions.Value}
                    validationEditIndex={validationEditIndex}
                    editedValidationItem={editedValidationItem}
                    validationContext={EValidationContext.Control}
                    onChange={(value: string) => {
                        change(validationExpressions.Name, value);
                    }}
                    updateEditedValidationItem={updateEditedValidationItem}
                    setValidationEditIndex={setValidationEditIndex}
                    outputOptions={
                        control.ControlId && control.ControlId.length ? outputOptions :
                            outputOptions.concat(
                                control.OutputValues ?
                                    control.OutputValues.map(o => { return { key: o.Id, text: o.Name } }) :
                                    []
                            )
                    }
                    defaultOutputOption={
                        control.OutputValues && control.OutputValues.length > 0
                            ? { key: control.OutputValues[0].Id, text: control.OutputValues[0].Name }
                            : null
                    }
                />
            </PivotItem>;
            pivots.push(newPivotElement);
            isNewBlockItem.push(newPivotElement);
        }

        let showPivotBlocker: boolean = !QueryBuilderHelper.canSaveQueryEditor() || validationEditIndex != null;

        return (

            isNewBlock ?
                <div className={'control-config-wrapper cascade' + (showPivotBlocker ? ' pivots-blocked' : '')}>
                    <Pivot linkSize={PivotLinkSize.large} >
                        {isNewBlockItem}
                    </Pivot >

                    <DialogFooter>
                        <Button tabIndex={1001}
                            buttonType={ButtonType.normal} disabled={isDeleteButtonDisabled(control)}
                            onClick={(event) => {
                                deleteControl();
                                event.stopPropagation();
                            }}>Delete</Button>
                        <Button tabIndex={1002}
                            buttonType={ButtonType.normal} onClick={() => { closeDialog(false, null, true) }}>Cancel</Button>
                        <Button tabIndex={1003} onBlur={() => { DOMHelper.focusOnFirstModalTabbableControl(); }}
                            buttonType={ButtonType.primary} onClick={() => { closeDialog(true, optionsDefinedByJSON, true) }}>Save</Button>
                    </DialogFooter>

                    {store.getState().modalState.modal.openModal === EModalType.ControlConfig &&
                        store.getState().modalState.controlConfig === control.ComponentId ? <OutputSelectContainer /> : null}
                </div>
                :
                <div className={'control-config-wrapper cascade' + (showPivotBlocker ? ' pivots-blocked' : '')}>

                    {showPivotBlocker ? <div className={"pivot-blocker"} onClick={showPivotErrorMessage}></div> : null}
                    {<Pivot linkSize={PivotLinkSize.large}>
                        {pivots}
                    </Pivot>
                    }
                    {!showBlockContent && showBlockTabs ?
                        <DialogFooter>
                            <Button tabIndex={1001}
                                buttonType={ButtonType.normal} disabled={isDeleteButtonDisabled(control)}
                                // onClick={() => { closeDialog(true, optionsDefinedByJSON) }}
                                onClick={(event) => {
                                    deleteControl();
                                    event.stopPropagation();
                                }}
                            >Delete</Button>
                            <Button tabIndex={1002}
                                buttonType={ButtonType.normal} onClick={() => { changeCurrentControlIndex(-1); }}>Cancel</Button>
                            <Button tabIndex={1003} onBlur={() => { DOMHelper.focusOnFirstModalTabbableControl(); }}
                                buttonType={ButtonType.primary} onClick={() => {
                                    closeDialog(true, optionsDefinedByJSON, false)
                                }}>Save</Button>
                        </DialogFooter> : null
                    }

                    {store.getState().modalState.modal.openModal === EModalType.ControlConfig &&
                        store.getState().modalState.controlConfig === control.ComponentId ? <OutputSelectContainer /> : null}
                </div >

        );

    };

};


// WEBPACK FOOTER //
// ./source/ts/components/controls/control-config.tsx